angular.module('aprima-legacy-common').factory(
    'LanguageFactory', ['gettextCatalog', 'LocalStorageRepository', 'TranslateService', function LanguageFactory(gettextCatalog, LocalStorageRepository, TranslateService) {

        'use strict';

        var currentLang = {code: gettextCatalog.currentLanguage};
        var langOptions = [
            {
                name: 'English',
                id: 'en_US'
            },
            {
                name: 'Spanish',
                id: 'es_MX'
            }
        ];

        //sometimes the language has a '-' in it which doesnt match our language formats with '_'
        function normalizeToUnderscore(language) {
            if (language) {
                return language.replace('-', '_');
            }
            return language;
        }

        function updateCurrentLangCode(code) {
            currentLang.code = gettextCatalog.currentLanguage = normalizeToUnderscore(code);
            TranslateService.use(currentLang.code);
        }

        function setLang(language) {
            updateCurrentLangCode(language);
            LocalStorageRepository.setLang(gettextCatalog.currentLanguage);
        }

        function getLang() {
            var currentLangCode = (currentLang.code) ?  normalizeToUnderscore(currentLang.code) : 'en_US';
            updateCurrentLangCode(currentLangCode);
            return currentLang;
        }

        function getActiveLanguage(){
            return _.find(langOptions, {id : getLang().code});
        }

        return {
            setLang: setLang,
            getLang: getLang,
            getLangOptions: langOptions,
            getActiveLanguage: getActiveLanguage
        };
    }]);
